import type { ReactNode } from 'react';
import { Drawer as MantineDrawer } from '@mantine/core';
import { useI18n } from '@/shared/i18n';

export function Drawer({
  isOpen,
  title,
  children,
  onClose,
  position = 'right',
  size = 'md',
  dismissible = true,
  testId,
}: {
  isOpen: boolean;
  title: ReactNode;
  children: ReactNode;
  onClose: () => void;
  position?: 'left' | 'right' | 'bottom' | 'top';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  dismissible?: boolean;
  testId?: string;
}) {
  const { t } = useI18n();

  return (
    <MantineDrawer
      opened={isOpen}
      onClose={onClose}
      title={title}
      position={position}
      size={size}
      radius="md"
      padding="md"
      closeOnClickOutside={dismissible}
      closeOnEscape={dismissible}
      withCloseButton={dismissible}
      data-testid={testId}
      closeButtonProps={{
        'aria-label': t('common.close'),
        ...({ 'data-testid': 'drawer-close-btn' } as Record<string, string>),
      }}
    >
      {children}
    </MantineDrawer>
  );
}
